import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as NoteSvg } from './assets/note.svg';

const NoteIcon = React.forwardRef((args, ref) => <SvgIcon component={NoteSvg} ref={ref} {...args} />);

export default NoteIcon;
